import { useState } from 'react';
import { TableInput } from '../../../components/common';
import { Table } from '../../../components/ui/renderTable/styled';
import { Checkbox } from '@mui/material';

interface IProps {
  moduleData: any;
  isView?: boolean;
}
const style1 = {
  fontSize: '1.8rem',
};
const TableForm = ({ moduleData, isView = false }: IProps) => {
  const [render, setRender] = useState(false);

  return (
    <Table style={{ width: '60vw', maxWidth: '800px' }}>
      <thead>
        <tr>
          <th style={{ ...style1 }}>Deptt (NOT OK)</th>
          <th style={{ ...style1 }}></th>
          <th style={{ ...style1 }}>Concern Person</th>
          <th style={{ ...style1 }}>Deptt (OK)</th>
          <th style={{ ...style1 }}></th>
          <th style={{ ...style1 }}>Concern Person</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <th>QA</th>
          <td>
            <Checkbox
              checked={moduleData.not_ok_dept_qa === true}
              onChange={(e) => {
                moduleData.not_ok_dept_qa = e.target.checked;
                setRender((prev) => !prev);
              }}
            />
          </td>
          <td>
            <TableInput
              isView={isView}
              name="not_ok_dept_qa_concern_person"
              key="not_ok_dept_qa_concern_person"
              type="text"
              value={moduleData.not_ok_dept_qa_concern_person}
              onChange={(e) => {
                moduleData.not_ok_dept_qa_concern_person = e.target.value;
                setRender((prev) => !prev);
              }}
            />
          </td>
          <th>QA</th>
          <td>
            <Checkbox
              checked={moduleData.ok_dept_qa === true}
              onChange={(e) => {
                moduleData.ok_dept_qa = e.target.checked;
                setRender((prev) => !prev);
              }}
            />
          </td>
          <td>
            <TableInput
              isView={isView}
              name="ok_dept_qa_concern_person"
              key="ok_dept_qa_concern_person"
              type="text"
              value={moduleData.ok_dept_qa_concern_person}
              onChange={(e) => {
                moduleData.ok_dept_qa_concern_person = e.target.value;
                setRender((prev) => !prev);
              }}
            />
          </td>
        </tr>
        <tr>
          <th>Tool & Engg</th>
          <td>
            <Checkbox
              checked={moduleData.not_ok_dept_tool_engg === true}
              onChange={(e) => {
                moduleData.not_ok_dept_tool_engg = e.target.checked;
                setRender((prev) => !prev);
              }}
            />
          </td>
          <td>
            <TableInput
              isView={isView}
              name="not_ok_dept_tool_engg_concern_person"
              key="not_ok_dept_tool_engg_concern_person"
              type="text"
              value={moduleData.not_ok_dept_tool_engg_concern_person}
              onChange={(e) => {
                moduleData.not_ok_dept_tool_engg_concern_person =
                  e.target.value;
                setRender((prev) => !prev);
              }}
            />
          </td>
          <th>Tool & Engg</th>
          <td>
            <Checkbox
              checked={moduleData.ok_dept_tool_engg === true}
              onChange={(e) => {
                moduleData.ok_dept_tool_engg = e.target.checked;
                setRender((prev) => !prev);
              }}
            />
          </td>
          <td>
            <TableInput
              isView={isView}
              name="ok_dept_tool_engg_concern_person"
              key="ok_dept_tool_engg_concern_person"
              type="text"
              value={moduleData.ok_dept_tool_engg_concern_person}
              onChange={(e) => {
                moduleData.ok_dept_tool_engg_concern_person = e.target.value;
                setRender((prev) => !prev);
              }}
            />
          </td>
        </tr>
        <tr>
          <th>Purchase</th>
          <td>
            <Checkbox
              checked={moduleData.not_ok_dept_purchase === true}
              onChange={(e) => {
                moduleData.not_ok_dept_purchase = e.target.checked;
                setRender((prev) => !prev);
              }}
            />
          </td>
          <td>
            <TableInput
              isView={isView}
              name="not_ok_dept_purchase_concern_person"
              key="not_ok_dept_purchase_concern_person"
              type="text"
              value={moduleData.not_ok_dept_purchase_concern_person}
              onChange={(e) => {
                moduleData.not_ok_dept_purchase_concern_person = e.target.value;
                setRender((prev) => !prev);
              }}
            />
          </td>
          <th>Purchase</th>
          <td>
            <Checkbox
              checked={moduleData.ok_dept_purchase === true}
              onChange={(e) => {
                moduleData.ok_dept_purchase = e.target.checked;
                setRender((prev) => !prev);
              }}
            />
          </td>
          <td>
            <TableInput
              isView={isView}
              name="ok_dept_purchase_concern_person"
              key="ok_dept_purchase_concern_person"
              type="text"
              value={moduleData.ok_dept_purchase_concern_person}
              onChange={(e) => {
                moduleData.ok_dept_purchase_concern_person = e.target.value;
                setRender((prev) => !prev);
              }}
            />
          </td>
        </tr>
        <tr>
          <th>Store</th>
          <td>
            <Checkbox
              checked={moduleData.not_ok_dept_store === true}
              onChange={(e) => {
                moduleData.not_ok_dept_store = e.target.checked;
                setRender((prev) => !prev);
              }}
            />
          </td>
          <td>
            <TableInput
              isView={isView}
              name="not_ok_dept_store_concern_person"
              key="not_ok_dept_store_concern_person"
              type="text"
              value={moduleData.not_ok_dept_store_concern_person}
              onChange={(e) => {
                moduleData.not_ok_dept_store_concern_person = e.target.value;
                setRender((prev) => !prev);
              }}
            />
          </td>
          <th>Store</th>
          <td>
            <Checkbox
              checked={moduleData.ok_dept_store === true}
              onChange={(e) => {
                moduleData.ok_dept_store = e.target.checked;
                setRender((prev) => !prev);
              }}
            />
          </td>
          <td>
            <TableInput
              isView={isView}
              name="ok_dept_store_concern_person"
              key="ok_dept_store_concern_person"
              type="text"
              value={moduleData.ok_dept_store_concern_person}
              onChange={(e) => {
                moduleData.ok_dept_store_concern_person = e.target.value;
                setRender((prev) => !prev);
              }}
            />
          </td>
        </tr>
        <tr>
          <th>Despatch</th>
          <td>
            <Checkbox
              checked={moduleData.not_ok_dept_dispatch === true}
              onChange={(e) => {
                moduleData.not_ok_dept_dispatch = e.target.checked;
                setRender((prev) => !prev);
              }}
            />
          </td>
          <td>
            <TableInput
              isView={isView}
              name="not_ok_dept_dispatch_concern_person"
              key="not_ok_dept_dispatch_concern_person"
              type="text"
              value={moduleData.not_ok_dept_dispatch_concern_person}
              onChange={(e) => {
                moduleData.not_ok_dept_dispatch_concern_person = e.target.value;
                setRender((prev) => !prev);
              }}
            />
          </td>
          <th>Despatch</th>
          <td>
            <Checkbox
              checked={moduleData.ok_dept_dispatch === true}
              onChange={(e) => {
                moduleData.ok_dept_dispatch = e.target.checked;
                setRender((prev) => !prev);
              }}
            />
          </td>
          <td>
            <TableInput
              isView={isView}
              name="ok_dept_dispatch_concern_person"
              key="ok_dept_dispatch_concern_person"
              type="text"
              value={moduleData.ok_dept_dispatch_concern_person}
              onChange={(e) => {
                moduleData.ok_dept_dispatch_concern_person = e.target.value;
                setRender((prev) => !prev);
              }}
            />
          </td>
        </tr>
        <tr>
          <th>Operators</th>
          <td>
            <Checkbox
              checked={moduleData.not_ok_dept_operator === true}
              onChange={(e) => {
                moduleData.not_ok_dept_operator = e.target.checked;
                setRender((prev) => !prev);
              }}
            />
          </td>
          <td>
            <TableInput
              isView={isView}
              name="not_ok_dept_operator_concern_person"
              key="not_ok_dept_operator_concern_person"
              type="text"
              value={moduleData.not_ok_dept_operator_concern_person}
              onChange={(e) => {
                moduleData.not_ok_dept_operator_concern_person = e.target.value;
                setRender((prev) => !prev);
              }}
            />
          </td>
          <th>Operators</th>
          <td>
            <Checkbox
              checked={moduleData.ok_dept_operator === true}
              onChange={(e) => {
                moduleData.ok_dept_operator = e.target.checked;
                setRender((prev) => !prev);
              }}
            />
          </td>
          <td>
            <TableInput
              isView={isView}
              name="ok_dept_operator_concern_person"
              key="ok_dept_operator_concern_person"
              type="text"
              value={moduleData.ok_dept_operator_concern_person}
              onChange={(e) => {
                moduleData.ok_dept_operator_concern_person = e.target.value;
                setRender((prev) => !prev);
              }}
            />
          </td>
        </tr>
        <tr>
          <th>Production</th>
          <td>
            <Checkbox
              checked={moduleData.not_ok_dept_production === true}
              onChange={(e) => {
                moduleData.not_ok_dept_production = e.target.checked;
                setRender((prev) => !prev);
              }}
            />
          </td>
          <td>
            <TableInput
              isView={isView}
              name="not_ok_dept_production_concern_person"
              key="not_ok_dept_production_concern_person"
              type="text"
              value={moduleData.not_ok_dept_production_concern_person}
              onChange={(e) => {
                moduleData.not_ok_dept_production_concern_person =
                  e.target.value;
                setRender((prev) => !prev);
              }}
            />
          </td>
          <th>Production</th>
          <td>
            <Checkbox
              checked={moduleData.ok_dept_production === true}
              onChange={(e) => {
                moduleData.ok_dept_production = e.target.checked;
                setRender((prev) => !prev);
              }}
            />
          </td>
          <td>
            <TableInput
              isView={isView}
              name="ok_dept_production_concern_person"
              key="ok_dept_production_concern_person"
              type="text"
              value={moduleData.ok_dept_production_concern_person}
              onChange={(e) => {
                moduleData.ok_dept_production_concern_person = e.target.value;
                setRender((prev) => !prev);
              }}
            />
          </td>
        </tr>
      </tbody>
    </Table>
  );
};

export default TableForm;
